import { withFeatureBranch } from '@wix/da-shared-react/pkg/redux/flags';
import { default as CustomBox } from './CustomBox';
import { default as CustomBoxV2 } from '../Custom__status_backgrounds';

export default withFeatureBranch({
  status_backgrounds: CustomBoxV2,
})(CustomBox as any);
